import { createStyles, makeStyles } from "@material-ui/core";
import React, { useMemo, useState } from "react";
import { useEffect } from "react";
import { CompletedContainer } from "../components/signup/completed/CompletedContainer";
import { LeadCompleted } from "../components/signup/completed/LeadCompleted";
import { SignupCompleted } from "../components/signup/completed/SignupCompleted";
import { UnavailableComponent } from "../components/signup/completed/UnavailableComponent";
import { AcquirerForm } from "../components/signup/forms/AcquirerForm";
import { LeadForm } from "../components/signup/forms/LeadForm";
import { SubscriptionForm } from "../components/signup/forms/SubscriptionForm";
import { UserDetailsForm } from "../components/signup/forms/UserDetailsForm";
import { VenueDetailsForm } from "../components/signup/forms/VenueDetailsForm";
import { SignupLayout } from "../components/signup/SignupLayout";
import { SignupSidebar } from "../components/signup/SignupSidebar";
import { SelfSignupProvider, useSignup } from "../components/signup/state/SelfSignup";
import { setStage, setTitle } from "../components/signup/state/signup.action";
import { titles } from "../components/signup/state/Titles";
import { ESignupStages } from "../components/signup/types";
import { subscriptionsMap } from "../const/subscriptions";
import { hosts } from "../yoello-lib/modules/host/Hosts";

export const IntegrationHosts = [ "deliverect", "ncr"]

export function SignupContainer() {
    return <SelfSignupProvider>
        <SignupLayout SidebarComponent={SignupSidebar}>
            <Container />
        </SignupLayout>
    </SelfSignupProvider>
}


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            border: '1px solid #E8EAF4',
            boxSizing: 'border-box',
            borderRadius: '1rem',
            padding: '2.1875rem 3.75rem',
            position: "relative",
        }
    })
)



function Container() {
    const classes = useStyles();
    const { stage } = useSignup();
    function renderEntry() {
        switch (stage) {
            case ESignupStages.DETAILS:
                return <DetailsContainer />;
            case ESignupStages.VENUE:
                return <VenueDetailsForm />
            case ESignupStages.SUBSCRIPTION:
                return <SubscriptionsContainer />;
            case ESignupStages.INVALIDLOCATION:
                return <UnavailableComponent />;
            case ESignupStages.COMPLETED:
                return <SignupCompletedContainer />;
            case ESignupStages.ACQUIRER:
                return <AcquirerForm />;
        }
    }

    return <div className={classes.root}>
        {renderEntry()}
    </div>
}

function DetailsContainer() {
    const { host } = useSignup();
    // @ts-ignore
    return host === "partners" ? <UserDetailsForm host={host}/> : <LeadForm />;
}

function SubscriptionsContainer() {
    const { dispatch, venueData, selectedSubscription, selectSubscription, goBack, callLeadsAPI } = useSignup();
    const [isLoading, setIsLoading] = useState(false);
    async function onSubmit() {
        const paymentPackage = selectedSubscription ? subscriptionsMap[selectedSubscription] : undefined;
        if (paymentPackage) {
            setIsLoading(true);
            await callLeadsAPI({ pricing_plan: paymentPackage });
            setIsLoading(false);
        }
        dispatch(setStage(ESignupStages.COMPLETED));
    }
    return <SubscriptionForm
        venueData={venueData}
        goBack={goBack}
        selectedSubscription={isLoading ? null : selectedSubscription}
        onSubmit={onSubmit}
        selectSubscription={selectSubscription}

    />
}

function SignupCompletedContainer() {
    const { venueData, selectedSubscription, selectSubscription, host, dispatch, stage, title } = useSignup();
    //@TODO Maybe revist this an have a think about a better way
    const isPartner = host === hosts.partners;

    const isLead = useMemo(() => {
        return host === hosts.rms || host === hosts.cardsaver || host === hosts.worldpay || host === hosts.zerobubble || host === hosts.bna
    }, [host]);

    const isAvailable = !isPartner || selectedSubscription === "1";

    useEffect(() => {
        let newTitle = "";
        if (isAvailable) {
            newTitle = titles[host][ESignupStages.COMPLETED];
        } else {
            newTitle = titles[host].interest;
        }
        if (title !== newTitle) {
            dispatch(setTitle(newTitle))
        }
        // eslint-disable-next-line
    }, [title, selectedSubscription, stage, isAvailable, host])

    return <CompletedContainer
        setSubscription={selectSubscription}
        isLarge={true}
        isAvailable={isAvailable}
        venueData={venueData}
        AvailableComponent={isLead ? <LeadCompleted/> : <SignupCompleted/>}
        getStartedTextKey="signup.newVenue.getStartedSignup"
    />
}